<template>
  <b-row>
    <b-container>
      <h2 class="mb-2">Baixa de Contratos</h2>

      <b-overlay :show="showLoading" :opacity="1" variant="light" rounded="sm">
        <template #overlay>
          <div class="d-flex align-items-center">
            <strong>Processando arquivo, aguarde...</strong>
            <b-icon icon="stopwatch" font-scale="3" animation="cylon" />
            <b-spinner small type="grow" variant="primary" />
            <b-spinner type="grow" variant="primary" />
            <b-spinner small type="grow" variant="primary" />
          </div>
        </template>

        <b-card>
          <b-form>
            <b-form-group label="Arquivo de Baixa">
              <b-form-file
                v-model="file"
                placeholder="Arraste ou selecione o arquivo"
                drop-placeholder="Arraste o arquivo aqui"
              />
            </b-form-group>

            <b-button
              variant="primary"
              class="btn-upload"
              :disabled="!file"
              @click="upload"
            >
              Enviar Arquivo
            </b-button>
          </b-form>
        </b-card>
        <b-card v-if="contractsList.length" class="mt-2">
          <h4 class="mb-2">Contratos Processados</h4>

          <b-table
            striped
            hover
            medium
            responsive
            :items="contractsList"
            :fields="tableFields"
            :per-page="perPage"
            :current-page="currentPage"
             class="auto-width-table"
          />

          <b-pagination
            v-model="currentPage"
            :total-rows="contractsList.length"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-2"
          />
        </b-card>
      </b-overlay>
    </b-container>
  </b-row>
</template>

<script>
import {
  BFormFile,
  BFormGroup,
  BButton,
  BRow,
  BCard,
  BPagination,
  BContainer,
  BForm,
  BSpinner,
  BOverlay,
  BIcon,
  BTable,
} from "bootstrap-vue";
import { formatDate, formatTaxId } from "@/utils"; 

export default {
  components: {
    BFormFile,
    BFormGroup,
    BButton,
    BRow,
    BCard,
    BContainer,
    BPagination,
    BForm,
    BSpinner,
    BOverlay,
    BIcon,
    BTable,
  },

  data() {
    return {
      file: null,
      showLoading: false,
      renderPage: true,
      contractsList: [],
      currentPage: 1,
      perPage: 10,

      tableFields: [
        { key: "externalReference", label: "Referência" },
        { key: "queryDate", label: "Data Consulta" },
        { key: "contractId", label: "Contrato" },
        { key: "participantCnpj", label: "CNPJ Participante", thStyle: { minWidth: "200px" } },
        { key: "holderCnpj", label: "CNPJ Detentor", thStyle: { minWidth: "200px" } },
        { key: "effectType", label: "Tipo Efeito" },
        { key: "operationMode", label: "Modalidade" },
        { key: "contractorDocument", label: "Contratante" , thStyle: { minWidth: "200px" }},
        { key: "amount", label: "Valor" },
        { key: "portfolio", label: "Carteira" },
        { key: "dueDate", label: "Vencimento" },
      ],

      effectTypeMap: {
        1: "Constituição de garantia",
        2: "Cessão fiduciária",
        3: "Trava de domicílio bancário",
        4: "Reserva de recebíveis",
        5: "Bloqueio judicial",
        6: "Penhor",
      },

      operationModeMap: {
        1: "Antecipação de recebíveis",
        2: "Garantia de operação",
        3: "Financiamento",
        4: "Cessão",
        5: "Capital de giro",
        6: "Desconto de duplicata",
      },
    };
  },

  methods: {
    async upload() {
      this.showLoading = true;

      try {
        const text = await this.file.text();
        this.parseContracts(text);
        this.success();
      } catch (err) {
        this.error();
      }
      this.showLoading = false;
    },

    parseContracts(text) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const lines = text.split("\n").filter((l) => l.trim());

      const result = lines
        .map((line) => line.split(";"))
        .filter((cols) => {
          const cnpjMatch = cols[3] === "04659982000189";

          const [day, month, year] = cols[10].split("/");
          const dueDate = new Date(`${year}-${month}-${day}`);
          dueDate.setHours(0, 0, 0, 0);

          const isExpired = dueDate < today;

          return cnpjMatch && isExpired;
        })
        .map((cols) => cols[0]);

      const payload = {
        data: result,
      };

      this.contractsList = lines
      .map(line => line.split(';'))
      .filter(cols => {
        const cnpjMatch = cols[3] === "04659982000189"

        const [day, month, year] = cols[10].split("/")
        const dueDate = new Date(`${year}-${month}-${day}`)

        return cnpjMatch && dueDate < today
      })
      .map(cols => ({
        externalReference: cols[0],
        queryDate: formatDate(cols[1]),
        contractId: cols[2],
        participantCnpj: formatTaxId(cols[3]),
        holderCnpj: formatTaxId(cols[4]),
        effectType: this.effectTypeMap[cols[5]],
        operationMode: this.operationModeMap[cols[6]],
        contractorDocument: formatTaxId(cols[7]),
        amount: this.formatCurrency(cols[8]),
        portfolio: cols[9],
        dueDate: formatDate(cols[10]),
      }));
    },

    formatCurrency(value) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      }).format(value);
    },

    success() {
      this.$swal({
        icon: "success",
        html: "<span>Contratos baixados com sucesso</span>",
      });
    },

    error() {
      this.$swal({
        icon: "error",
        html: "<span>Erro ao processar arquivo</span>",
      });
    },
  },
};
</script>
